import React from "react";
import Error from "../../../components/Error";
import Typography from "@material-ui/core/Typography";
import DashboardLayout from "../../app/components/layouts/DashboardLayout";
import { AdapterButton } from "../../../components/Adopter";

export default function NotFound() {
  return (
    <DashboardLayout showCart={false}>
      <Error>
        <Typography>Whoops... Route not found</Typography>
        <AdapterButton variant={"outlined"} to={"/0"} color={"primary"}>
          Go home
        </AdapterButton>
      </Error>
    </DashboardLayout>
  );
}
